module.exports = __webpack_public_path__ + "img/img_uniform_claim.d2ad0b7b.jpg";